import { backendRequest } from "@services/requestService";
import { API_BASE_URL, BASE_SERVICE_URL, CUSTOMER_SERVICES } from "@constants/services/apiRoutes";
import { FetchCustomerData } from "@customTypes/responses/customer";

export const fetchCustomerInfo = async () => {
  const url = `${API_BASE_URL}${BASE_SERVICE_URL.customer}${CUSTOMER_SERVICES.info}`;

  const data = await backendRequest<FetchCustomerData>(url, "GET");
  return data;
};
